import {
  ACTION_DELETE_PAGE__REQUEST,
  ACTION_DELETE_PAGE__SUCCESS,
  ACTION_DELETE_PAGE__FAIL,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_DELETE_PAGE__REQUEST:
    case ACTION_DELETE_PAGE__SUCCESS:
      return null;

    case ACTION_DELETE_PAGE__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
